var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.$numbers(_vm.value).formatCurrency({ mantissa: 2, thousandSeparated: true })))])}
var staticRenderFns = []

export { render, staticRenderFns }